<template>
  <div>
    这里是移动端头部
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>